export default "__VITE_ASSET__9d1f4489__"